<template>
  <div class="public-content order">
    <div class="breadcrumb">{{ codeType == 'taobao' ? '淘宝订单' : codeType == 'douYin' ? '抖音订单' : formInline.originType == 'VIDEO' ? '影像季拓客订单' : '拓客订单' }}</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col v-permission="'oms:admin:order:one'" :span="6">
            <el-form-item label="订单号:">
              <el-input v-model="formInline.orderNo" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col v-permission="'oms:admin:order:one'" :span="6" v-if="codeType == 'taobao'">
            <el-form-item label="淘宝单号:">
              <el-input v-model="formInline.outOrderNo" placeholder="请输入淘宝订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col v-permission="'oms:admin:order:one'" :span="6" v-if="codeType == 'douYin'">
            <el-form-item label="抖音单号:">
              <el-input v-model="formInline.outOrderNo" placeholder="请输入抖音订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id" @click="storeListByCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支付状态:">
              <el-select v-model="formInline.paymentStatus" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="已支付" value="PAID"></el-option>
                <el-option label="未支付" value="UNPAID"></el-option>
                <el-option label="平台未支付" value="STORE_UNPAID"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支付方式:">
              <!-- <el-select v-model="formInline.paymentType" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="微信" value="WXPAY"></el-option>
                <el-option label="支付宝" value="ALIPAY"></el-option>
                <el-option label="码支付" value="PROMO"></el-option>
                <el-option label="余额支付" value="VPAY"></el-option>
              </el-select> -->
              <el-select clearable v-model="formInline.paymentType" placeholder="请选择">
                <el-option v-for="(v, k) in $config.paymentType" :key="k" :label="v" :value="k" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支付方：">
              <el-select v-model="formInline.payerType" clearable placeholder="请选择">
                <el-option label="平台" value="STORE" />
                <el-option label="终端用户" value="USER" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品码:" v-if="codeType != 'taobao' && codeType != 'douYin'">
              <el-input v-model="formInline.promoCode" placeholder="请输入产品码" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结算状态:">
              <el-select v-model="formInline.settlementStatus" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option label="未结算" value="UNSETTLED"></el-option>
                <el-option label="结算中" value="IN_PROGRESS"></el-option>
                <el-option label="已结算" value="SETTLED"></el-option>
                <el-option label="拒绝结算" value="REJECTED"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单状态:">
              <el-select v-model="formInline.orderStatus" placeholder="请选择" clearable>
                <el-option label="" value="">全部</el-option>
                <el-option v-for="(v, k) in $config.orderStatus" :key="k" :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="formInline.originType != 'VIDEO'">
            <el-form-item label="订单来源:">
              <el-select v-model="formInline.originType" placeholder="请选择" clearable>
                <el-option v-for="(v, k) in $config.originTypes" :key="k" :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开票状态:">
              <el-select clearable v-model="formInline.invoice" :filter-method="selectSalemanList" filterable placeholder="请选择">
                <el-option label="未开票" value="notInvoice"></el-option>
                <el-option label="已开票" value="invoice"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="用户名:">
              <el-input v-model="formInline.userCreatedPhone" placeholder="请输入用户名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="创建日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <!-- 业务人员才能结算  v-if="$store.state.user.userType === 'SALESMAN'" -->
            <el-button @click="(queryInfo.pageNum = 1), onSubmit()" round>查询</el-button>
            <el-button @click="exportExcel" v-permission="['oms:admin:orderSettlement:export']" round>导出Excel</el-button>
            <el-button @click="settlement()" round type="primary" v-if="$hasPermission('oms:admin:orderSettlement:apply') && codeType != 'taobao' && codeType != 'douYin'">结算</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" fit border :row-class-name="rowClassName" style="width: 100%" :empty-text="!empty ? '正在获取数据中，请稍后...' : '暂无数据'" v-if="empty">
          <el-table-column label="订单号" fixed="left" min-width="210px">
            <template v-slot="scope">
              <span @click="orderInfo(scope.row)" class="color-blue">{{ scope.row.orderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userCreatedPhone" label="用户名" min-width="130px">
            <template v-slot="scope"> {{ $msg.filterBridal(scope.row.userCreatedPhone) }} </template>
          </el-table-column>
          <el-table-column label="淘宝订单号" fixed="left" min-width="210px" v-if="codeType == 'taobao'">
            <template v-slot="scope">
              <span>{{ scope.row.outOrderNo ? scope.row.outOrderNo.split(',')[1] : scope.row.outOrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="抖音订单号" fixed="left" min-width="210px" v-if="codeType == 'douYin'">
            <template v-slot="scope">
              <span>{{ scope.row.outOrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="storeCode" label="平台号" min-width="100px"></el-table-column>
          <el-table-column prop="storeName" label="平台名称" min-width="130px"></el-table-column>
          <el-table-column prop="salesman" label="业务" min-width="130px"></el-table-column>
          <el-table-column prop="onlinePriceTotal" label="总价" min-width="130px"></el-table-column>
          <el-table-column prop="priceTotal" label="会员总价" min-width="80px">
          </el-table-column>
          <el-table-column prop="cpriceTotal" label="零售总价" min-width="80px" v-if="codeType != 'taobao' && codeType != 'douYin'"></el-table-column>
          <el-table-column prop="priceReal" label="实付总价" min-width="80px">
            <template slot-scope="scope"> {{ scope.row.paymentStatus === 'UNPAID' ? '0' : scope.row.priceReal }} </template>
          </el-table-column>
          <el-table-column label="结算金额" min-width="80px">
            <template slot-scope="scope"> {{ scope.row.settlementAmount === undefined ? 0 : scope.row.settlementAmount }} </template>
          </el-table-column>
          <el-table-column label="支付状态" min-width="90px">
            <template slot-scope="scope"> {{ scope.row.paymentStatus === 'UNPAID' ? '未支付' : scope.row.paymentStatus === 'STORE_UNPAID' ? '平台未支付' : '已支付' }} </template>
          </el-table-column>
          <el-table-column prop="paymentType" label="支付方式" min-width="180px">
            <template slot-scope="scope"> {{ $config.paymentType[scope.row.paymentType] || scope.row.paymentType }}<span v-if="scope.row.promoCode">({{ scope.row.promoCode }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="payerType" label="支付方" min-width="90px">
            <template slot-scope="scope"> {{ scope.row.payerType === 'STORE' ? '平台' : scope.row.payerType === 'USER' ? '终端用户' : '' }} </template>
          </el-table-column>
          <!--<el-table-column prop="storeType" label="平台类型">-->
          <!--<template slot-scope="scope">-->
          <!--<span>{{-->
          <!--scope.row.storeType === 'WXBIZ' ? '微商'-->
          <!--:scope.row.storeType === 'STUDIO' ? '影楼'-->
          <!--:scope.row.storeType === 'FULFILLER' ? '后期':''-->
          <!--}}</span>-->
          <!--</template>-->
          <!--</el-table-column>-->
          <el-table-column prop="dateSubmitted" label="创建日期" min-width="170px"></el-table-column>
          <el-table-column prop="datePayment" label="支付日期" min-width="170px"></el-table-column>
          <el-table-column prop="originType" label="订单来源">
            <template slot-scope="scope">
              <span>{{ $config.originTypes[scope.row.originType] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderStatus" label="订单状态">
            <!-- <template slot-scope="scope">
              <span>{{ $config.orderStatus[scope.row.orderStatus] }}</span>
            </template> -->
            <template slot-scope="scope">
              <span class="color-blue" @click="getOrderStatus(scope.row.orderNo)">{{ $config.orderStatus[scope.row.orderStatus] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="开票状态" min-width="80px">
            <template slot-scope="scope">
              <div :style="scope.row.invoice ? 'color:blue;cursor: pointer;' : ''" v-if="scope.row.invoice" @click="invoicePage(scope.row.orderNo)"> 已开票</div>
              <div :style="scope.row.invoice ? 'color:blue;cursor: pointer;' : ''" v-else>未开票 </div>
            </template>
          </el-table-column>
          <el-table-column label="结算状态" min-width="80px" v-if="codeType != 'taobao' && codeType != 'douYin'">
            <template slot-scope="scope">
              <span> {{ scope.row.settlementStatus === 'UNSETTLED' ? '未结算' : scope.row.settlementStatus === 'IN_PROGRESS' ? '结算中' : scope.row.settlementStatus === 'SETTLED' ? '已结算' :
                scope.row.settlementStatus === 'REJECTED' ? '拒绝结算' : '' }} </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100px" fixed="right">
            <template v-slot="scope">
              <span :class="{ 'color-blue': scope.row.urgentStatus == 0 }"
                v-if="(codeType == 'taobao' || codeType == 'douYin' ? $hasPermission('oms:admin:orderTb:urgent') : $hasPermission('oms:admin:orderTk:urgent')) && (scope.row.orderStatus == 'CONFIRMED' || scope.row.orderStatus == 'PROCESSING' || scope.row.orderStatus == 'RENDER_DONE' || scope.row.orderStatus == 'DONE_DOWNLOAD')"
                @click="scope.row.urgentStatus == 0 ? urgent(scope.row) : ''">{{ scope.row.urgentStatus == 0 ? '加急' : scope.row.urgentStatus == 1 ? '已加急' : '' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo="queryInfo"></v-pagination>
    </div>
    <order-dialog ref="orderDialogRef"></order-dialog>
    <applyDialog ref="applyDialog" :storeListByCodeContent="storeListByCode"></applyDialog>
  </div>
</template>
<script>
import applyDialog from './applyDialog.vue'
import VPagination from '@/components/Pagination/index.vue'
import OrderDialog from '@/components/Dialog/OrderDialog/OrderStatusDialog/index.vue'
import { getByOmsOrderNo } from '@/api/finance'
import { order, orderPaymentTypeStatistic, orderLogList, orderExport, getUrgentOrderNo } from '@/api/oms'
import { storeTypeGetStoreTypeList, storeQueryListByCode, getSalesmanByFullName, storeQueryListByName, getAllUsersByUserName } from '@/api/crm'
export default {
  name: 'order',
  components: {
    VPagination,
    OrderDialog,
    applyDialog
  },
  watch: {
    '$route.path': {
      handler (val, oldVal) {
        if (val) {
          console.log('vaaaaalll', sessionStorage.getItem('searchFlag'))
          if (sessionStorage.getItem('searchFlag') === 'true') {
            this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
            this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
            this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
            this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))
            console.log('this.formInline', this.formInline)
            this.value2[0] = this.formInline.dateStart ? this.formInline.dateStart.split(' ')[0] : ''
            this.value2[1] = this.formInline.dateEnd ? this.formInline.dateEnd.split(' ')[0] : ''
            sessionStorage.removeItem('searchFlag')
          } else {
            // 首次进入列表页,清除缓存中的搜索条件
            sessionStorage.removeItem('queryParams')
            sessionStorage.removeItem('queryInfo')
            sessionStorage.removeItem('storeListByCode')
            sessionStorage.removeItem('salemanList')
            this.formInline = {
              channel: 'B2C',
              orderNo: '', // 订单号
              outOrderNo: '',
              userName: '', // 用户名
              storeId: null,
              storeCode: '',
              storeName: '',
              agentName: '',
              orderType: null, // 订单类型
              paymentStatus: '', // 支付状态
              paymentType: null, // 支付方式
              orderStatus: '', // 订单状态
              dateStart: null,
              dateEnd: null,
              salesmanId: null,
              settlementStatus: '', // 结算状态
              invoice: null, // 开票状态
              promoCode: '',
              originType: null
            }
            this.queryInfo = {
              total: 0,
              pageNum: 1,
              pageSize: 10
            }
            this.storeListByCode = []
            this.salemanList = []
          }
          if (this.$route.query.paymentStatus === 'UNPAID') {
            this.formInline.paymentStatus = 'UNPAID'
            this.formInline.orderStatus = 'SUBMITTED'
          }
          this.codeType = val.indexOf('taobao') !== -1 ? 'taobao' : ''
          if (val.indexOf('douYin') !== -1) this.codeType = 'douYin'
          this.formInline.originType = val.indexOf('taobao') !== -1 ? 'TB' : null
          if (val.indexOf('douYin') !== -1) this.formInline.originType = 'DY'
          this.formInline.channel = val.indexOf('taobao') !== -1 ? 'B2B' : 'B2C'
          if (val.indexOf('douYin') !== -1) this.formInline.channel = 'B2B'
          console.log(' this.formInline', this.formInline)
          this.formInline.dateStart = this.value2[0] + ' 00:00:00'
          this.formInline.dateEnd = this.value2[1] + ' 23:59:59'
          if (val.indexOf('TKOrderYxj') !== -1) {
            this.formInline.originType = 'VIDEO'
          }
          this.onSubmit()
        }
      },
      deep: true,
      immediate: true
    },
    value2: {
      handler (val, oldVal) {
        console.log('vall', val, oldVal)
        if (val) {
          this.formInline.dateStart = val[0] + ' 00:00:00'
          this.formInline.dateEnd = val[1] + ' 23:59:59'
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      codeType: '',
      userList: [],
      salemanList: [],
      storeListByCode: [],
      queryInfo: {
        total: 0,
        pageNum: 1, // 当前显示第几页
        pageSize: 10 // 每一页显示条数
      },
      formInline: {
        channel: 'B2C',
        orderNo: '', // 订单号
        outOrderNo: '',
        userName: '', // 用户名
        storeId: null,
        storeCode: '',
        storeName: '',
        agentName: '',
        orderType: null, // 订单类型
        paymentStatus: '', // 支付状态
        paymentType: null, // 支付方式
        orderStatus: '', // 订单状态
        dateStart: null,
        dateEnd: null,
        salesmanId: null,
        settlementStatus: '', // 结算状态
        invoice: null, // 开票状态
        promoCode: '',
        originType: null
      },
      empty: false,
      tableData: [],
      basicsInfo: {
        storeId: '',
        storeCode: '',
        storeName: '',
        fullName: '',
        storeTypeList: []
      },
      value2: [
        this.$moment()
          .subtract(6, 'months')
          .format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          // const myDate = new Date();
          // myDate.setMonth(myDate.getMonth() - 1);
          // const beforeDate = myDate.getFullYear() + '-' + (myDate.getMonth() + 1) + '-' + myDate.getDate();
          // console.log(beforeDate)
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  // created () {
  //   console.log('vaaaaalll', sessionStorage.getItem('searchFlag'))
  //   if (sessionStorage.getItem('searchFlag') === 'true') {
  //     this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
  //     this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
  //     this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
  //     this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))
  //     console.log('this.formInline', this.formInline)
  //     this.value2[0] = this.formInline.dateStart ? this.formInline.dateStart.split(' ')[0] : ''
  //     this.value2[1] = this.formInline.dateEnd ? this.formInline.dateEnd.split(' ')[0] : ''
  //     sessionStorage.removeItem('searchFlag')
  //   } else {
  //     // 首次进入列表页,清除缓存中的搜索条件
  //     sessionStorage.removeItem('queryParams')
  //     sessionStorage.removeItem('queryInfo')
  //     sessionStorage.removeItem('storeListByCode')
  //     sessionStorage.removeItem('salemanList')
  //   }
  //   if (this.$route.query.paymentStatus === 'UNPAID') {
  //     this.formInline.paymentStatus = 'UNPAID'
  //     this.formInline.orderStatus = 'SUBMITTED'
  //   }
  //   this.onSubmit(this.queryInfo)
  // },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    // 加急
    urgent (row) {
      getUrgentOrderNo(row.orderId).then(res => {
        if (res.data.success) {
          this.$message.success('加急成功')
          this.onSubmit()
        }
      })
    },
    orderInfo (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      console.log('queryParams', this.formInline)
      this.$router.push({ path: '/orderdetail', query: { orderNo: row.orderNo, way: 1, type: 'TokerOrder', outType: this.codeType } })
    },
    // 查看发票
    invoicePage (val) {
      console.log('vaaaaalll', val)
      getByOmsOrderNo(val).then(res => {
        console.log(res)
        let receipt = res?.data?.data?.receipt
        if (receipt) {
          window.open(receipt.url ? receipt.url : '')
        }
      })
    },
    // 结算按钮
    settlement () {
      console.log(this.storeListByCode, 'storeListByCode')
      console.log(this.basicsInfo.storeCode, 'storeCode')
      console.log('formInline.storeId: ', this.formInline)
      if (this.formInline.storeId === null) {
        this.$notify({
          title: '提示',
          message: '请选择平台号',
          type: 'error'
        })
        return
      }
      this.$refs.applyDialog.show()
    },
    onSubmit () {
      console.log(this.formInline, 'this.formInline')
      // if (sessionStorage.getItem('searchFlag')) {
      //   sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      //   sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      //   sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      //   sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      // }
      this.empty = false
      this.tableData = []
      console.log('onApply', sessionStorage.getItem('searchFlag'))
      let voData = Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value]))
      if (voData.invoice === 'notInvoice') voData.invoice = false
      else if (voData.invoice === 'invoice') voData.invoice = true
      if (voData.paymentType === 'VPAY') {
        voData.paymentTypes = ['VP_ACCT', 'VP_BONUS', 'VP_SETTLE']
        voData.paymentType = null
      }
      order({
        page: this.queryInfo.pageNum - 1,
        size: this.queryInfo.pageSize,
        vo: voData
      }).then(res => {
        this.queryInfo.total = res.data.data.total
        this.tableData = res.data.data.content
      }).finally(res => {
        this.empty = true
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    getOrderStatus (orderId) {
      this.$refs.orderDialogRef.show(orderId)
    },
    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let param = JSON.parse(JSON.stringify(this.formInline))
      // if (!param.dateStart) {
      //   param.dateStart =
      //     this.$moment()
      //       .subtract(1, 'months')
      //       .format('YYYY-MM-DD') + ' 00:00:00'
      //   param.dateEnd = this.$moment().format('YYYY-MM-DD') + ' 00:00:00'
      // }
      Object.keys(param).forEach(key => (param[key] === '' || param[key] === null) && delete param[key])
      orderExport(param).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = event => {
          let a = document.createElement('a')
          let _fileName = (this.codeType == 'taobao' ? '淘宝订单' : this.codeType == 'douYin' ? '抖音订单' : '拓客订单') + '.xls'
          if (this.value2.length) {
            _fileName = (this.codeType == 'taobao' ? '淘宝订单' : this.codeType == 'douYin' ? '抖音订单' : '拓客订单') + this.value2[0] + '-' + this.value2[1] + '.xls'
          }
          // let _fileName = '订单表' + this.value2[0] + '-' + this.value2[1] + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    handleSelect (item) {
      this.formInline.storeId = item.id
      this.basicsInfo.storeName = item.companyName
    },
    selectUserList (val) {
      if (val.trim()) {
        getAllUsersByUserName(val).then(res => {
          if (res.data.success) {
            this.userList = res.data.data
          }
        })
      }
    },
    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            console.log(res.data.data, 'res.data.data')
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    // querySearchAsync(queryString, cb) {
    //   storeQueryListByCode(queryString).then(res => {
    //     res.data.data.forEach(item => {
    //       item.value = item.code
    //     });
    //     cb(res.data.data)
    //   })
    // },
    SelectStoreName (item) {
      console.log(item, '377')
      this.formInline.storeId = item.id
      this.basicsInfo.storeCode = item.code
    },
    queryStoreNameAsync (queryString, cb) {
      storeQueryListByName(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    selectFullName (item) {
      this.formInline.salesmanId = item.id
    },
    queryFullNameAsync (queryString, cb) {
      // 改成业务的模糊查询
      getSalesmanByFullName(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.fullName
        })
        cb(res.data.data)
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}

@{deep} .el-date-editor--daterange.el-input__inner {
  width: 250px;
}
</style>
